import PropTypes from 'prop-types';
import DynamicCustomField from '../../../../apps/interactions/form/components/dynamic-custom-field';

const CustomFields = ({ field, form, ...rest }) => {
  const { value = {}, name } = field;
  const { orgCustomFields = [], hasCustomFields = false } = rest;
  const { setFieldValue, values, setTouched, touched, errors } = form;

  const setCustomFieldTouched = (id, shouldValidate = true) => {
    const { custom_field = {} } = touched;
    custom_field[id] = true;
    setTouched({ ...touched, custom_field }, shouldValidate);
  };

  const handleChange = (id, newVal) => {
    setFieldValue(name, { ...value, [id]: newVal });
  };

  return (
    <>
      {hasCustomFields && orgCustomFields?.length
        ? orgCustomFields?.map((customField = {}) => {
            return (
              <DynamicCustomField
                key={customField.id}
                formValues={values}
                fieldValue={value[customField.id]}
                customField={customField}
                handleChange={handleChange}
                handleTouched={(shouldValidate) => setCustomFieldTouched(customField.id, shouldValidate)}
                error={errors?.[`custom_field.${customField.id}`]}
                touched={touched?.custom_field?.[customField.id]}
              />
            );
          })
        : null}
    </>
  );
};

CustomFields.propTypes = {
  field: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func,
    setTouched: PropTypes.func,
    errors: PropTypes.object,
    touched: PropTypes.object,
    values: PropTypes.object,
    dirty: PropTypes.bool,
    isValid: PropTypes.bool,
    handleSubmit: PropTypes.func,
  }),
};

export default CustomFields;
